import { render, staticRenderFns } from "./CustomerListSide.vue?vue&type=template&id=49cbf8d2&scoped=true&"
import script from "./CustomerListSide.vue?vue&type=script&lang=js&"
export * from "./CustomerListSide.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListSide.vue?vue&type=style&index=0&id=49cbf8d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbf8d2",
  null
  
)

export default component.exports